import React from 'react'
import { Card } from 'react-bootstrap'
import { formatPhone, provinceMap } from '../lib/utils'

const PersonView = ({ person }) => {
  const { firstname, surname, cellphone, email } = person
  return (
    <>
      <h2>{firstname} {surname}</h2>

      <dl class='row'>
        <dt class='col-sm-3'>Cellphone</dt>
        <dd class='col-sm-9'><a href={`tel:+${cellphone}`}>{formatPhone(cellphone)}</a></dd>

        <dt class='col-sm-3'>Email</dt>
        <dd class='col-sm-9'><a href={`mailto:${email}`}>{email}</a></dd>
      </dl>

      {person.pubRep ? <PubRepInfo pubRep={person.pubRep} /> : null}
      {person.staff ? <StaffInfo staff={person.staff} /> : null}
      {person.candidate ? <CandidateInfo candidate={person.candidate} /> : null}
    </>
  )
}

const PubRepInfo = ({ pubRep }) => (
  <Card className='mb-3'>
    <Card.Header as='h5'>Public representative</Card.Header>
    <Card.Body>
      <dl class='row'>
        <dt class='col-sm-3'>Position</dt>
        <dd class='col-sm-9'>{pubRep.position}</dd>

        <dt class='col-sm-3'>Legislature</dt>
        <dd class='col-sm-9'>{pubRep.legislature}</dd>

        <dt class='col-sm-3'>Province</dt>
        <dd class='col-sm-9'>{provinceMap[pubRep.province]}</dd>
      </dl>
    </Card.Body>
  </Card>
)

const StaffInfo = ({ staff }) => (
  <Card className='mb-3'>
    <Card.Header as='h5'>Staff member</Card.Header>
    <Card.Body>
      <dl class='row'>
        <dt class='col-sm-3'>Position</dt>
        <dd class='col-sm-9'>{staff.position}</dd>

        <dt class='col-sm-3'>Department</dt>
        <dd class='col-sm-9'>{staff.department}</dd>
      </dl>
    </Card.Body>
  </Card>
)

const CandidateInfo = ({ candidate }) => (
  <Card className='mb-3'>
    <Card.Header as='h5'>Candidate</Card.Header>
    <Card.Body>
      <dl class='row'>
        <dt class='col-sm-3'>Election</dt>
        <dd class='col-sm-9'>{candidate.elections.join(', ')}</dd>
      </dl>
      <p>For further information contact the Candidate Selection department.</p>
    </Card.Body>
  </Card>
)

export default PersonView
